app.farmnetControllers.addCustomCode('seedCoreController', function(
  $scope,
  controller,
  $injector
) {
  let coreUnitService = $injector.get('coreUnitService'),
    searchService = $injector.get('search.service'),
    seedSearchService = $injector.get('seedSearch.service'),
    seedOriginalOptions,
    harvestOriginalOptions;

  // autocomplete field
  $scope.customHeaderTemplate = require('./seedCoreCustomHeader.html');

  $scope.$watch('details.seed.seedUnit', function(newValue, oldValue) {
    if (newValue !== oldValue && $scope.details) {
      coreUnitService.updateOptions($scope.details.seed, seedOriginalOptions, {
        entity: 'seed'
      });
    }
  });
  $scope.$watch('details.seed.harvestUnit', function(newValue, oldValue) {
    if (newValue !== oldValue && $scope.details) {
      //no error here, its' the seed.harvestUnit*
      coreUnitService.updateOptions(
        $scope.details.seed,
        harvestOriginalOptions,
        { entity: 'harvest' }
      );
    }
  });

  ang.overrideFunction(controller, 'onAfterLoad', function(baseFn, model) {
    baseFn(model);

    //first time, save original options, as they might be different from those of the original unit
    seedOriginalOptions = model.seed.seedStockyardDisplayUnitOptions;
    harvestOriginalOptions = model.seed.harvestStockyardDisplayUnitOptions;

    //init
    coreUnitService.updateOptions($scope.details.seed, seedOriginalOptions, {
      entity: 'seed'
    });
    coreUnitService.updateOptions($scope.details.seed, harvestOriginalOptions, {
      entity: 'harvest'
    });
  });

  ang.overrideFunction(controller, 'toSaveModel', function(baseFn, model) {
    model = baseFn(model);

    if (model) {
      // don't save these fields
      delete model.seed.seedUnitOptions;
      delete model.seed.seedStockyardDisplayUnitOptions;
      delete model.seed.harvestUnitOptions;
      delete model.seed.harvestStockyardDisplayUnitOptions;
    }

    return model;
  });

  // return deleted item to the catalog
  ang.overrideFunction(controller, 'delete', function(baseFn, popupAnswer) {
    if (
      popupAnswer == 'ok' &&
      controller.details.seed &&
      controller.details.seed.sysSeed &&
      controller.details.seed.sysSeed.id
    ) {
      // currently dont have the local index anymore
      // searchIndex.undoExcludeFromIndex(controller.details.seed.sysSeed.id);
    }

    return baseFn(popupAnswer);
  });

  ang.overrideFunction(controller, 'onItemAdded', function(baseFn, addedItem) {
    // currently dont have the local index anymore
    //searchIndex.excludeFromIndex(addedItem.id);
  });

  /**
   * Overwrites the function 'propertyChanged' of the coreCommonController if called from the seedCoreController.
   * Sets an array 'dirtyField' into the current seed and adds the name of the field that was changed in FrontEnd.
   */
  ang.overrideFunction(controller, 'propertyChanged', function(
    baseFn,
    fieldName,
    id
  ) {
    if (fieldName === 'harvestType.earningNet') {
      let harvestType = _(controller.details.seed_harvestTypes).filter(function(
        item
      ) {
        return item.id === id;
      })[0];
      setDirtyFlag(harvestType, 'earningNet');
    } else {
      setDirtyFlag(controller.details.seed, fieldName);
    }
    // if harvestUnit in seed changed then set the dirty flag for all harvestTypes
    if (fieldName === 'harvestUnit') {
      _(controller.details.seed_harvestTypes).each(function(item) {
        setDirtyFlag(item, 'harvestUnit');
      });
    }

    return baseFn(fieldName);
  });

  function setDirtyFlag(model, fieldName) {
    if (model) {
      if (!model.dirtyFlags) {
        model.dirtyFlags = [];
      }
      model.dirtyFlags.push(fieldName);
    }
  }

  /**
   * Sets the field 'dirtyFlags' to <null> if existent.
   * The dirtyFlags field can be set to the request object in order to give the backend information about changed form fields
   * in the FrontEnd. See also:
   * 'seedCoreCustom.ang.overrideFunction(controller, "propertyChanged", function(baseFn, fieldName))'
   */
  ang.overrideFunction(controller, 'resetDirtyFlags', function() {
    let model = controller.details.seed;
    model.dirtyFlags = null;

    // reset dirty flags for all harvestTypes
    _(controller.details.seed_harvestTypes).each(function(item) {
      item.dirtyFlags = null;
    });
  });

  /**
   * Overwrites the function 'handleSaveResponse' of the coreCommonController if called from the seedCoreController.
   * Clears the 'dirtyField' array after it was sent to the BackEnd.
   */
  ang.overrideFunction(controller, 'handleSaveResponse', function(
    baseFn,
    data,
    sentModel
  ) {
    controller.resetDirtyFlags();
    controller.markCurrentStateSaved();

    return baseFn(data, sentModel);
  });

  $scope.search = seedSearchService.search;
  $scope.searchSelected = function(selectedItem) {
    controller.doAddByTemplate(selectedItem, {
      doNotRefreshIndexList: true,
      openDetails: true
    });
  };

  /**
   * Rendering search context
   */
  switch (app.credentials.company.countryIsoCode) {
    // intentional fall-through
    case 'DEU':
    case 'FRA':
    case 'POL':
    case 'AUT':
    case 'CHE':
      $scope.showAutoComplete = true;
      break;
    default:
      $scope.showAutoComplete = false;
      break;
  }
  //$scope.showAutoComplete = ('DEU' === app.credentials.company.countryIsoCode);

  return controller;
});
